import React, { useState } from "react"
import { Controller, useForm } from "react-hook-form"
import Select from "react-select/async"
import DatePicker from "react-datepicker"
import { useRouter } from "next/router"
import axios from "axios"
import { Preloader } from "../universal/preloader"

type Props = {
  onSuccess?: () => void
  brands: { name: string; affiliate_status: string }[]
}

interface IInput {
  name: string
  email: string
  subject: string
  body: string
  brand: string
  affiliate_status?: string
  purchase_amount: string
  order_num: string
  message: string
  date?: Date | null
}

export const RewardForm: React.FC<Props> = ({ brands }) => {
  const router = useRouter()
  const [date, setDate] = useState<Date>(new Date())
  const [loading, setLoading] = useState(false)
  const {
    control,
    register,
    setValue,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm<IInput>()

  const filterNames = (inputValue: string) => {
    let result = brands.filter((i) => i.name.toLowerCase().includes(inputValue.toLowerCase()))
    return result.slice(0, 20)
  }

  const loadOptions = (inputValue: string, callback: (options: { name: string; affiliate_status: string }[]) => void) => {
    setTimeout(() => {
      const result = filterNames(inputValue)
      callback(result)
    }, 1000)
  }

  const onSUbmit = (data: IInput) => {
    const postData = {
      ...data,
      date: data.date?.toISOString(),
      type: "missed_reward",
      affiliate_status: data.affiliate_status == "hoopla_doopla",
    }

    setLoading(true)
    axios
      .post("/api/contact", postData)
      .then((res) => {
        if (res.status == 200) {
          router.push("/contact/success")
        } else {
          router.push("/contact/error")
        }
      })
      .catch((err) => {
        setLoading(false)
        router.push("/contact/error")
      })
  }

  return (
    <form acceptCharset="utf-8" className="contact-form" onSubmit={handleSubmit(onSUbmit)}>
      <label>your name {errors.name && <small className="error">(Required!)</small>}</label>
      <input {...register("name", { required: { value: true, message: "Name is required" } })} placeholder="Enter your name" autoComplete="off" />

      <label>email {errors.email && <small className="error">(Required!)</small>}</label>
      <input type="text" {...register("email", { required: true })} placeholder="address@email.com" />

      <label>Subject {errors.subject && <small className="error">(Required!)</small>}</label>
      <input type="text" {...register("subject", { required: true })} placeholder="Write a subject" />

      {/* Brands names */}

      <label>Brand name {errors.brand && <small className="error">(Required!)</small>}</label>
      <Controller
        name="brand"
        control={control}
        rules={{ required: true }}
        render={({ field }) => (
          <Select
            cacheOptions
            defaultOptions
            getOptionLabel={(i) => i.name}
            getOptionValue={(i) => i.name}
            loadOptions={loadOptions}
            onChange={(v) => {
              field.onChange(v?.name)
              setValue("affiliate_status", v?.affiliate_status)
            }}
            className={"brand-select"}
            styles={{
              singleValue: () => {
                return {
                  overflow: "unset",
                }
              },
            }}
            ref={field.ref}
            name={field.name}
            placeholder="Select brand"
          />
        )}
      />
      <input type="hidden" name="affiliate_status" value={watch("affiliate_status") ?? ""} />

      <label>Purchase Amount Before Taxes & Shipping {errors.purchase_amount && <small className="error">(Required!)</small>}</label>
      <input type="text" {...register("purchase_amount", { required: true })} placeholder="ex. $50" />

      <label>order number</label>
      <input type="text" {...register("order_num")} placeholder="ex. 412713634" />

      {/* Date picker */}
      <label>Date of purchase {errors.date && <small className="error">(Required!)</small>}</label>
      <Controller
        name="date"
        control={control}
        rules={{ required: true }}
        render={({ field }) => (
          <DatePicker
            name={field.name}
            selected={field.value}
            dateFormat="yyyy/MM/dd"
            placeholderText="Select date"
            autoComplete="off"
            onChange={(date) => {
              if (date) {
                field.onChange(date)
                setDate(date)
              }
            }}
          />
        )}
      />

      <label>additional message (optional)</label>
      <textarea placeholder="Write your message" {...register("body")} className="input-text message-input" />
      {/* <textarea {...register("message")} placeholder="Write your message" className="input-text message-input" /> */}

      <button type="submit" className="btn-lg-label bg-primary secondary">
        Submit
        {loading && <Preloader color="white" />}
      </button>
    </form>
  )
}
